import { registerEnum } from '@adornis/baseql/metadata/register.js';

export enum ParticipationState {
  PARTICIPATED = 'participated',
  IN = 'in',
  LEFT = 'left',
  WAITING = 'waiting',
  SUSPENDED = 'suspended',
}

export enum ProductRuntimeState {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  PLANNED = 'PLANNED',
}

registerEnum({ enum: ProductRuntimeState, name: 'ProductRuntimeState' });
